var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 11.1321C8.96703 11.1321 7.3125 9.47755 7.3125 7.44407C7.3125 5.41059 8.96703 3.75606 11.0005 3.75606C13.034 3.75606 14.6885 5.41059 14.6885 7.44407C14.6885 9.47755 13.034 11.1321 11.0005 11.1321Z",
    stroke: "#848484",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11523 19.2442C4.1157 19.2382 4.11616 19.2322 4.11708 19.2262C4.4513 15.7189 7.40535 12.976 11.0003 12.976C14.5952 12.976 17.5488 15.7185 17.884 19.2258",
    stroke: "#848484",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.5,
    r: 10.5,
    stroke: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestIcon);
export default __webpack_public_path__ + "static/media/guestIcon.f5b829fb5aa8ba029aabbdc7f85a480f.svg";
export { ForwardRef as ReactComponent };